import { BroadcastChannel } from 'broadcast-channel';
import isError from 'lodash/isError';

const reduxBroadcastChannel = new BroadcastChannel('reduxBroadcastChannel');

const evtListener = dispatch => ev => {
  dispatch({
    ...ev,
    broadcast: false,
  });
};

export const broadcast = ({ dispatch }) => {
  reduxBroadcastChannel.addEventListener('message', evtListener(dispatch));

  return next => action => {
    const { broadcast: isBroadcast, payload } = action;
    /**
     * postMessage throws a DataCloneError when it's not serializeable.
     * One case where that happens is when a `broadcast: true` action returns an error.
     * e.g. in `get` when session is timed out it rejects: `Promise.reject(new Error(SESSION_TIMEOUT_ERROR))`
     *
     * Starting with a simple payload check to cover most cases, but we may expand this with a
     * more thorough `isSerializeable` check in the future... or a try/catch.
     */
    if (isBroadcast && !isError(payload)) {
      reduxBroadcastChannel.postMessage(action);
    }

    return next(action);
  };
};

export default broadcast;
